
import { Options, Vue, prop } from "vue-class-component";
import LpButton from "@/app/ui/components/lp-button/index.vue";
import LpInput from "@/app/ui/components/lp-input/index.vue";

class Props {
  isOpen = prop<boolean>({ default: false, type: Boolean });
  isLoading = prop<boolean>({ default: false, type: Boolean });
}

@Options({
  components: { LpButton, LpInput },
  watch: {
    isOpen(val: boolean) {
      if (val) {
        (this as PickupCancelConfirmModal).reason = "";
      }
    }
  },
  emits: ["confirm", "cancel"]
})
export default class PickupCancelConfirmModal extends Vue.with(Props) {
  reason = "";

  get isReasonValid(): boolean {
    const trimmedReason = this.reason.trim();
    return trimmedReason.length >= 3 && this.reason.length <= 255;
  }

  onConfirm(): void {
    if (!this.isReasonValid || this.isLoading) return;
    this.$emit("confirm", this.reason.trim());
  }

  onCancel(): void {
    if (this.isLoading) return;
    this.$emit("cancel");
  }
}
